import React from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";

import Card from "@components/Card";
import Div from "@components/Div";
import { H4 } from "@components/Heading";
import Icon from "@components/Icon";
import { LinkArrow } from "@components/Link";
import { Text } from "@components/Text";
import ProgressSpinner from "@components/ProgressSpinner";

import { ConfirmConsentDialog } from "./components";
import { useConsentStatusCard } from "./ConsentStatusCard.hooks";

const ConsentStatusCard = ({
  orderSummaryProps,
  onUpdateOrderSummaryProps,
}) => {
  const { messages } = useIntl();
  const {
    handleCloseConfirmDialog,
    handleConfirmConsent,
    handleOpenConfirmDialog,
    isConfirmDialogVisible,
    isLoading,
    orderDetails,
  } = useConsentStatusCard({ orderSummaryProps, onUpdateOrderSummaryProps });

  return (
    <Card borderRadius="10px">
      {isLoading && <ProgressSpinner />}

      {isConfirmDialogVisible && (
        <ConfirmConsentDialog
          orderDetails={orderDetails}
          onClose={handleCloseConfirmDialog}
          onConfirm={handleConfirmConsent}
        />
      )}

      <Div
        width={1}
        display="flex"
        flexDirection={["column", "column", "row"]}
        px={3}
        py="24px"
        gridGap={["24px", "24px", "60px"]}
        alignItems={["flex-start", "flex-start", "center"]}
        justifyContent="space-between"
      >
        <Div display="flex" flexDirection="column" gridGap="10px">
          <H4>{messages.title_consent_card}</H4>

          <Text>{messages.description_consent_card}</Text>
        </Div>

        <LinkArrow
          flexWrap="nowrap"
          label={messages.label_edit_consent_status}
          variant="secondary"
          onClick={handleOpenConfirmDialog}
        >
          <Icon ml={1} name="headerarrowright" />
        </LinkArrow>
      </Div>
    </Card>
  );
};

ConsentStatusCard.propTypes = {
  orderSummaryProps: PropTypes.object,
  onUpdateOrderSummaryProps: PropTypes.func,
};

export default ConsentStatusCard;
